function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { assignInlineVars as y } from "@vanilla-extract/dynamic";
import x from "classnames";
import { useIsInverseVariant as k } from "./theme-variant-context.js";
import { ButtonPrimary as I } from "./button.js";
import { useTheme as B } from "./hooks.js";
import m from "./stack.js";
import { Text6 as N, Text3 as C } from "./text.js";
import S from "./button-group.js";
import { container as E, inverseBorder as T, vars as V, contentVariants as l, iconContainer as $, largeImageContainer as b, largeImage as j, smallImage as A } from "./empty-state.css-mistica.js";
import { vars as a } from "./skins/skin-contract.css-mistica.js";
import { AspectRatioContainer as D } from "./utils/aspect-ratio-support.js";
import { getPrefixedDataAttributes as P } from "./utils/dom.js";
import { sprinkles as R } from "./sprinkles.css-mistica.js";
const G = (param)=>{
    let { title: c , description: d , button: e , buttonLink: p , largeImageUrl: o , imageUrl: i , icon: n , "aria-label": f , dataAttributes: g  } = param;
    const { isDarkMode: v  } = B(), s = k(), h = i ? /* @__PURE__ */ r("img", {
        className: A,
        alt: "",
        src: i
    }) : void 0, u = _object_spread_props(_object_spread({}, (e == null ? void 0 : e.type) === I ? {
        primaryButton: e
    } : {
        secondaryButton: e
    }), {
        link: p
    });
    return /* @__PURE__ */ t("div", _object_spread_props(_object_spread({
        className: x(E, s ? T : R({
            border: "regular"
        })),
        style: y({
            [V.backgroundColor]: s && !v ? a.colors.backgroundBrand : a.colors.backgroundContainer
        }),
        "aria-label": f,
        role: "region"
    }, P(g, "EmptyState")), {
        children: [
            /* @__PURE__ */ r("div", {
                style: {
                    flex: 1
                },
                children: /* @__PURE__ */ t(m, {
                    space: 24,
                    className: o ? l.largeImage : l.default,
                    children: [
                        h !== null && h !== void 0 ? h : n && /* @__PURE__ */ r("div", {
                            className: $,
                            children: n
                        }),
                        /* @__PURE__ */ t(m, {
                            space: 16,
                            children: [
                                /* @__PURE__ */ r(N, {
                                    as: "h1",
                                    children: c
                                }),
                                /* @__PURE__ */ r(C, {
                                    regular: !0,
                                    as: "p",
                                    color: s ? a.colors.inverse : a.colors.textSecondary,
                                    children: d
                                })
                            ]
                        }),
                        e && /* @__PURE__ */ r(S, _object_spread({}, u))
                    ]
                })
            }),
            /* @__PURE__ */ r("div", {
                style: {
                    flex: 1,
                    position: "relative"
                },
                children: o && /* @__PURE__ */ r(D, {
                    aspectRatio: 16 / 9,
                    className: b,
                    height: "100%",
                    children: /* @__PURE__ */ r("div", {
                        className: j,
                        style: {
                            backgroundImage: `url(${o})`
                        }
                    })
                })
            })
        ]
    }));
}, Z = G;
export { Z as default };
